import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageBreadcrumbComponent } from '../../../shared/components/common/page-breadcrumb/page-breadcrumb.component';
import { CompanySizeApiService } from '../../empresas/services/company-size-api.service';
import { CompanySize } from '../../empresas/models/empresa.model';
import { AuthService } from '../../auth-pages/services/auth.service';
import { ConfirmDialogService } from '../../../shared/services/confirm-dialog.service';
import { ToastService } from '../../../shared/services/toast.service';
import { HasPermissionDirective } from '../../../shared/directives/has-permission.directive';

@Component({
  selector: 'app-company-size-list',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    PageBreadcrumbComponent,
    HasPermissionDirective
  ],
  templateUrl: './company-size-list.component.html'
})
export class CompanySizeListComponent implements OnInit {
  items: CompanySize[] = [];
  loading = false;
  error = '';

  constructor(
    private api: CompanySizeApiService,
    private authService: AuthService,
    private router: Router,
    private confirmDialog: ConfirmDialogService,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
    this.cargar();
  }

  cargar(): void {
    this.loading = true;
    this.error = '';

    this.api.getAll({ page: 0, size: 100 }).subscribe({
      next: (data) => {
        this.items = data.content;
        this.loading = false;
      },
      error: (err) => {
        this.error = err.error?.message || 'Error al cargar los tamaños de empresa';
        this.loading = false;
        console.error('Error:', err);
      }
    });
  }

  nuevo(): void {
    this.router.navigate(['/config-empresas/tamanios/crear']);
  }

  editar(item: CompanySize): void {
    this.router.navigate(['/config-empresas/tamanios/editar', item.id]);
  }

  async eliminar(item: CompanySize): Promise<void> {
    const ok = await this.confirmDialog.confirmDanger({
      title: 'Eliminar tamaño',
      message: `¿Está seguro de eliminar el tamaño "${item.name}"?`
    });
    if (!ok) return;
    this.api.delete(item.id).subscribe({
      next: () => {
        this.cargar();
        this.toast.deleted('Tamaño', `Se eliminó "${item.name}" correctamente.`);
      },
      error: (err) => {
        this.toast.error({ title: 'Error', message: err.error?.message || 'Error al eliminar el tamaño' });
      }
    });
  }
}
